import Base from "@/controllers/base";
export default class Calendar extends Base {
  constructor(elem) {
    super(elem);
  }

  /* PLH: could not use data-controller because e-date takes a changed prop */
  static switchDate(input) {
    window.location = '/containers/calendar?date=' + input.value
  }
}
